export enum RequestStatuses {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
